import { useState } from 'react'
import { ReliabilityInfoDialog } from './ReliabilityInfoDialog'

interface ReliabilityScoreProps {
  progress: number
  isWhiteBackground?: boolean
}

const ReliabilityScore = ({ progress, isWhiteBackground = false }: ReliabilityScoreProps) => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false)
  const circumference = 2 * Math.PI * 40

  const dashOffset = circumference - (circumference * progress) / 100

  const progressColor = progress >= 60 ? '#00C874' : progress >= 30 ? '#FEAC4B' : '#AC3F3F'
  return (
    <>
      <ReliabilityInfoDialog
        isOpen={dialogIsOpen}
        onClose={() => setDialogIsOpen(!dialogIsOpen)}
        onReadMore={() =>
          window.open(
            'https://dupr.zendesk.com/hc/en-us/articles/26872333542676-What-is-the-Reliability-Score-What-is-a-Passing-Reliability-Score'
          )
        }
      />
      <div
        onClick={() => setDialogIsOpen(!dialogIsOpen)}
        style={{ position: 'relative', width: '32px', height: '32px' }}
      >
        <svg viewBox="0 0 100 100" style={{ position: 'absolute', width: '100%', height: '100%' }}>
          <circle
            cx="50"
            cy="50"
            r="40"
            fill="none"
            stroke={isWhiteBackground ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 255, 255, 0.1)'}
            strokeWidth="13"
            strokeDasharray={360}
            strokeLinecap="round"
            transform="rotate(-90 50 50)"
          />
          <circle
            cx="50"
            cy="50"
            r="40"
            fill="none"
            stroke={progressColor}
            strokeWidth="13"
            strokeDasharray={circumference}
            strokeDashoffset={dashOffset}
            strokeLinecap="round"
            transform="rotate(-90 50 50)"
          />
        </svg>
        <div
          style={{
            position: 'absolute',
            top: Math.round(progress) === 100 ? '46%' : '46%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
          }}
        >
          {progress !== 0 && (
            <span
              style={{
                fontSize: Math.round(progress) === 100 ? '11.5px' : '12px',
                color: isWhiteBackground ? '#333' : '#fff',
              }}
            >
              {Math.round(progress)}
            </span>
          )}
        </div>
      </div>
    </>
  )
}

export default ReliabilityScore
